<!-- 侧边栏 license by http://eleadmin.com -->
<template>
  <div class="ele-admin-sidebar ele-scrollbar-hide">
    <slot name="top" />
    <el-scrollbar class="ele-admin-sidebar-menu-wrap ele-scrollbar-hide">
      <div class="ele-admin-sidebar-menus">
        <el-menu
          v-if="useDeep"
          :class="themeClass"
          :collapse="collapse"
          :default-active="active"
          :unique-opened="uniqueOpen"
          :collapse-transition="false"
          :default-openeds="defaultOpeneds"
        >
          <template v-for="menu in data">
            <ele-pro-sidebar-item
              v-if="!menu.meta.hide"
              :key="menu.path"
              :item="menu"
              :collapse="collapse"
              :pop-class="themeClass"
            />
          </template>
        </el-menu>
        <ele-pro-sidebar-menus
          v-else
          :data="data"
          :collapse="collapse"
          :pop-class="themeClass"
          :default-active="active"
          :theme-class="themeClass"
          :unique-opened="uniqueOpen"
          :collapse-transition="false"
          :default-openeds="defaultOpeneds"
        />
      </div>
    </el-scrollbar>
    <slot name="bottom" />
  </div>
</template>

<script>
  import EleProSidebarItem from './ele-pro-sidebar-item.vue';
  import EleProSidebarMenus from './ele-pro-sidebar-menus.vue';

  export default {
    name: 'EleProSidebar',
    components: { EleProSidebarItem, EleProSidebarMenus },
    props: {
      // 侧边栏菜单数据
      data: Array,
      // 侧边栏菜单选中
      active: String,
      // 是否折叠菜单
      collapse: Boolean,
      // 侧边栏是否只保持一个子菜单展开
      uniqueOpen: Boolean,
      // 侧边栏默认展开的子菜单
      defaultOpeneds: Array,
      // 主题class, null | ele-menu-dark
      themeClass: String,
      // 是否使用递归渲染菜单item
      useDeep: Boolean
    }
  };
</script>
